import { useState } from "react";
import { Link } from "react-router-dom";
import { User, LogOut, Crown, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

export const UserMenu = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);

  if (!user) {
    return (
      <div className="flex items-center gap-2">
        <Link
          to="/login"
          data-testid="header-signin-btn"
          className="h-10 px-4 inline-flex items-center rounded-lg border border-slate-700 bg-transparent hover:bg-slate-800 text-slate-100 font-heading font-bold text-sm transition-colors"
        >
          Sign in
        </Link>
        <Link
          to="/upgrade"
          data-testid="header-upgrade-btn"
          className="h-10 px-4 inline-flex items-center gap-1.5 rounded-lg bg-amber-500 hover:bg-amber-400 text-slate-950 font-heading font-bold text-sm transition-colors"
        >
          <Crown className="w-4 h-4" /> Go Pro
        </Link>
      </div>
    );
  }

  const isPaid = user.plan && user.plan !== "free";

  return (
    <div className="relative">
      <Button
        type="button"
        variant="outline"
        data-testid="user-menu-btn"
        onClick={() => setOpen((v) => !v)}
        className="h-10 border-slate-700 bg-transparent hover:bg-slate-800 text-slate-200 gap-2"
      >
        {user.picture ? (
          <img src={user.picture} alt="" className="w-6 h-6 rounded-full" />
        ) : (
          <User className="w-4 h-4" />
        )}
        <span className="truncate max-w-[120px]">{user.name || user.email}</span>
        {isPaid && (
          <span className="text-[10px] font-mono-digit uppercase bg-amber-500/20 text-amber-300 border border-amber-500/40 rounded px-1.5 py-0.5">
            {user.plan}
          </span>
        )}
        <ChevronDown className="w-3.5 h-3.5" />
      </Button>
      {open && (
        <div
          data-testid="user-menu-dropdown"
          className="absolute right-0 mt-2 w-56 rounded-xl border border-slate-800 bg-[#131c2e] shadow-2xl shadow-black/60 z-20 overflow-hidden"
          onMouseLeave={() => setOpen(false)}
        >
          <div className="px-3 py-2.5 border-b border-slate-800 text-xs">
            <div className="font-mono-digit text-slate-300 truncate">{user.email}</div>
            <div className="text-slate-500 mt-0.5">Plan: {user.plan || "free"}</div>
          </div>
          {!isPaid && (
            <Link
              to="/upgrade"
              data-testid="menu-upgrade-link"
              className="flex items-center gap-2 px-3 py-2.5 text-sm text-amber-300 hover:bg-amber-500/10 transition-colors"
            >
              <Crown className="w-4 h-4" /> Upgrade to Pro
            </Link>
          )}
          <button
            type="button"
            data-testid="menu-logout-btn"
            onClick={async () => {
              setOpen(false);
              await logout();
            }}
            className="w-full flex items-center gap-2 px-3 py-2.5 text-sm text-slate-300 hover:bg-slate-800 transition-colors text-left"
          >
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      )}
    </div>
  );
};
